import { Chip, Tooltip, Typography } from "@mui/material";

interface Props {
  carrieAccessType?: CarrierAccessType;
  size?: "small" | "medium" | undefined;
}

export function SharedBookingChip(props: Props) {
  const { carrieAccessType, size = undefined } = props;

  if (carrieAccessType !== "SHARED_BOOKING_READ_AND_WRITE") {
    return null;
  }

  return (
    <Tooltip
      title={
        <Typography>This booking was shared with you by the owner.</Typography>
      }
    >
      <Chip variant="outlined" size={size} label="SHARED" color="info" />
    </Tooltip>
  );
}
